module.exports = __webpack_public_path__ + "static/luka-5710bcc2d218889bf37fa71806203c33.png";